import {Button} from "@/components/ui/button";
import React, {ReactNode} from "react";

interface Props {
    onClick?: () => void
    className?: string
    children: ReactNode
}
export const ButtonIcon = React.forwardRef<HTMLButtonElement, Props>(
  ({onClick, className, children}, ref) => {
    return (
      <Button
        ref={ref}
        variant={"default"}
        onClick={onClick}
        className={className}
        size={"icon"}
      >
        {children}
      </Button>
    )
  }
);